import React from 'react'
function UpcomingEvents() {
  return (
    <div>
          <div className="krishnagrofficemaountainer">
        <div className="album py-2">
          <div className="container">
            <br />


            <h2><b>An update will be released shortly
</b></h2>
          
<br/>
          </div>
        </div>

      </div>
    </div>
  )
}

export default UpcomingEvents